import ReAddressType from './ReAddressType'
import ReRegion from './ReRegion'
import RePriceFormationOrder from './RePriceFormationOrder'
import RePriceCalculationType from './RePriceCalculationType'
import ReOrgStatusType from './ReOrgStatusType'
import ReCountry from './ReCountry'
import ReAdministrativeTerritory from './ReAdministrativeTerritory'
import ReMeasurementUnit from './ReMeasurementUnit'
import ReConstructionMaterial from './ReConstructionMaterial'
import ReMessageToAdminType from './ReMessageToAdminTypes/index'
import ReCharacteristic from './ReCharacteristic'
import ReDistrict from './ReDistrict'
import RePossibleCharacteristic from './RePossibleCharacteristic'
import ReOrgs from './ReOrgs'
import ReOrgType from './ReOrgType'
import ReInfoOrgType from './ReInfoOrgType'
import ReLocalityType from './ReLocalityType'
import ReAddresses from "../NRI/ReAddress"

export default [

	{
		render : RePriceFormationOrder,
		text   : "Порядки формирования цены строительных материалов"
	},
	{
		render : ReMeasurementUnit,
		text   : "Единицы измерения строительных материалов"
	},
	{
		render : RePriceCalculationType,
		text   : "Тип расчёта средней цены строительных материалов"
	},
	{
		render  : ReConstructionMaterial,
		text    : "Каталог-классификатор",
		catalog : true
	},
	{
		render : ReCharacteristic,
		text   : "Перечень характеристик строительных материалов"
	},
	{
		render : RePossibleCharacteristic,
		text   : "Возможные варианты значений для характеристик строительных материалов"
	},
	{
		render : ReInfoOrgType,
		text   : "Категории организаций из перечня для обязательного представления сведений в ИСС"
	},
	{
		render : ReOrgs,
		text   : "Организации и индивидуальные предприниматели"
	},
	{
		render : ReOrgStatusType,
		text   : "Статусы организаций и индивидуальных предпринимателей"
	},
	{
		render : ReOrgType,
		text   : "Типы организаций и индивидуальных предпринимателей"
	},
	{
		render : ReCountry,
		text   : "Справочник стран мира"
	},
	{
		render : ReRegion,
		text   : "Справочник областей"
	},
	{
		render : ReDistrict,
		text   : "Справочник районов"
	},
	{
		render : ReAdministrativeTerritory,
		text   : "Справочник объектов административно-территориального деления"
	},
	{
		render : ReAddresses,
		text   : "Справочник улиц"
	},
	{
		render : ReLocalityType,
		text   : "Типы административно-территориальных единиц"
	},
	{
		render : ReAddressType,
		text   : "Типы улиц"
	},
	{
		render : ReMessageToAdminType,
		text   : "Типы сообщений администратору"
	}
]
